/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationConfirmationSmsCodeAliases {
  BUTTON_CONFIRM = 'button-confirm',
  BUTTON_CONFIRM_ACTION = 'button-confirm-action',
  BUTTON_RESEND_SMS_CODE = 'button-resend-sms-code',
  BUTTON_RESEND_SMS_CODE_ACTION = 'button-resend-sms-code-action',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FORM_SEND_SMS_CODE = 'form-send-sms-code',
  GLOBAL_ACTIONS_1 = 'global-actions-1',
  INPUT_SMS_CODE = 'input-sms-code',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LOADER_SEND_SMS_CODE = 'loader-send-sms-code',
  MODAL_SEND_SMS_CODE = 'modal-send-sms-code',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_6 = 'panel-6',
  PANEL_7 = 'panel-7',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_BTN_CONTINUE = 'panel-btn-continue',
  PANEL_BTN_RESEND = 'panel-btn-resend',
  PANEL_BTNS_2 = 'panel-btns-2',
  PANEL_BTNS_3 = 'panel-btns-3',
  PANEL_BTNS_ACTIONS = 'panel-btns-actions',
  PANEL_LOADER_SEND_SMS_CODE = 'panel-loader-send-sms-code',
  PANEL_TEXT_INFORMATION_RESEND_SMS = 'panel-text-information-resend-sms',
  PANEL_TEXT_INFORMATION_RESEND_SMS_5 = 'panel-text-information-resend-sms-5',
  SEND_SMS_CODE_FIELD = 'send-sms-code-field',
  SEND_SMS_CODE_PANEL = 'send-sms-code-panel',
  TEXT_INFORMATION_RESEND_SMS_CODE = 'text-information-resend-sms-code',
  TEXT_INFORMATION_SMS_CHECK = 'text-information-sms-check',
  TEXT_INFORMATION_SMS_CODE = 'text-information-sms-code',
}
export { AccountCreationConfirmationSmsCodeAliases };
